import { render, staticRenderFns } from "./ModalPopup.vue?vue&type=template&id=0969bf3d&scoped=true&"
import script from "./ModalPopup.vue?vue&type=script&lang=ts&"
export * from "./ModalPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ModalPopup.vue?vue&type=style&index=0&id=0969bf3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0969bf3d",
  null
  
)

export default component.exports